import { firestoreDb } from './firebase'
import { recordWorkspaceActivity, type WorkspaceActivityAction, type WorkspaceActivityTargetType } from './activityService'
import type { UploadHubLedgerAction } from '../types/schema'

export { INTEGRATION_ACTIVITY_EVENTS, type IntegrationActivityEvent } from '../../functions/src/shared/integrationActivityEvents'

export type LedgerEntryInput = {
  workspaceId: string
  userId: string
  userName?: string
  action: UploadHubLedgerAction | string
  targetId: string
  targetTitle?: string
  targetType?: string
  summary?: string
  metadata?: Record<string, unknown>
}

const summaryFor = (input: LedgerEntryInput): string => {
  if (input.summary) return input.summary
  const title = input.targetTitle ?? 'artifact'
  switch (input.action) {
    case 'FILE_UPLOADED': return `Uploaded ${title}`
    case 'BATCH_STARTED': return `Started batch ${title}`
    case 'BATCH_SCHEDULED': return `Scheduled batch ${title}`
    case 'BATCH_CANCELLED': return `Cancelled batch ${title}`
    case 'ARTIFACT_DELETED': return `Deleted ${title}`
    case 'ARTIFACT_RETAGGED': return `Retagged ${title}`
    case 'SYNC_TRIGGERED': return `Triggered sync for ${title}`
    default: return `Storage activity on ${title}`
  }
}

export const recordUploadHubActivity = async (input: LedgerEntryInput): Promise<void> => {
  if (!input.workspaceId || !input.userId) return
  await recordWorkspaceActivity(firestoreDb, {
    workspaceId: input.workspaceId,
    actorId: input.userId,
    actorName: input.userName ?? '',
    targetType: (input.targetType ?? 'STORAGE_ARTIFACT') as WorkspaceActivityTargetType,
    targetId: input.targetId,
    targetTitle: input.targetTitle ?? '',
    action: input.action as WorkspaceActivityAction,
    summary: summaryFor(input),
    metadata: input.metadata ?? {},
    deferredActionKey: 'UPLOAD_HUB_ACTIVITY',
  })
}
